import { IBmoTransaction } from '@shared/api';
import { formats } from '@shared/utils';
import moment from 'moment-timezone';

const hasMoreThanTwoDecimals = (value: number): boolean => {
    return value.toString().split('.')[1]?.length > 2;
};

const formatNumber = (value: number): string => {
    return hasMoreThanTwoDecimals(value) ? value.toFixed(2) : value.toString();
};

export const transformDate = (key: string, bmoTransaction: IBmoTransaction): string => {
    if (key === 'createDate' || key === 'modifyDate') {
        return moment(String(bmoTransaction[key as keyof typeof bmoTransaction])).format(formats.fullTime);
    }

    const value = bmoTransaction[key as keyof typeof bmoTransaction];
    if (typeof value === 'number') {
        return formatNumber(value);
    }

    return value?.toString() ?? '';
};
